import React, { useEffect, useMemo } from 'react';
import { HashRouter } from 'react-router-dom';
import { Routes, GlobalSettingProvider } from 'frontend';
import { ConfigProvider } from 'antd';
import { useSelector } from 'react-redux';
import { getUserInfo, userStore } from 'store/reducer/user';
import zhCN from 'antd/es/locale/zh_CN';
import routes from './config/routes';
import styles from './App.module.scss';

const App = (props: any) => {
  const userInfo = useSelector(userStore);
  const filterList = (list: any, keys: any) => {
    return list.filter((i: any) => {
      if (i.routes && i?.routes.length > 0) {
        i.routes = filterList(i?.routes, keys);
      }
      if (i?.isFirst && i?.routes.length == 0) {
        return false;
      }
      if (!i.key) {
        return true;
      }
      if (i?.key && !keys?.includes(i?.key)) {
        return false;
      }
      return true;
    });
  };
  const menus = useMemo(() => {
    // 'DATACENTER_DIALOG', 'ROBOT_DICTIONARY', 'AUTHORITY_USER', 'AUTHORITY_ROLE'
    const subMenuAuth = userInfo?.subMenuAuth || [];
    if (subMenuAuth.length > 0) {
      return filterList(routes, subMenuAuth);
    }
    return routes;
  }, [userInfo]);

  useEffect(() => {
    getUserInfo();
  }, []);
  return (
    <>
      <ConfigProvider locale={zhCN}>
        <GlobalSettingProvider siderMenuTheme="light">
          <div className={styles.root}>
            <HashRouter>
              <Routes routes={menus} />
            </HashRouter>
          </div>
        </GlobalSettingProvider>
      </ConfigProvider>
    </>
  );
};
export default App;
